import { useEffect } from "react";
import { ZEFFY_DONATE_URL } from "@/lib/api";

// All donate flows now go directly to the external Zeffy donation form.
// This route exists for backwards-compat with old links/bookmarks.
export default function DonateRedirect() {
    useEffect(() => {
        window.location.replace(ZEFFY_DONATE_URL);
    }, []);
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#F2E8D5] p-6 text-center" data-testid="donate-redirect">
            <div>
                <div className="text-xs tracking-[0.3em] uppercase text-stone-500">Redirecting</div>
                <h1 className="mt-2 font-serif text-3xl">Taking you to our secure donation page…</h1>
                <p className="mt-3 text-stone-600">
                    If you aren&apos;t redirected automatically,{" "}
                    <a href={ZEFFY_DONATE_URL} className="text-brand-purple underline" data-testid="donate-redirect-link">
                        click here to donate
                    </a>.
                </p>
            </div>
        </div>
    );
}
